<template>
  <el-dialog
    title="待复制信息"
    :visible.sync="dialogFormVisible"
    width="600px"
    class="copy-order-info"
  >
    <div class="item">
      <div class="label">产品名称：</div>
      <div class="value">
        {{ project_name }}
        {{ trip_type === 1 ? ' 拼团' : trip_type === 2 ? ' 包团' : '' }}
        {{ interval_time ? interval_time + '场' : '' }}
      </div>
    </div>
    <div class="item">
      <div class="label">出行日期：</div>
      <div class="value">{{ use_date }}</div>
    </div>
    <div v-for="(item, index) in orders" :key="index">
      <div class="item">
        <div class="label">联系人：</div>
        <div class="value">
          {{ item.contact.name }} / {{ item.user_num }}人 / {{ item.contact.mobile }}
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'CopyInfoDialog',
  data() {
    return {
      dialogFormVisible: false,
      orders: [],
      project_name: '',
      use_date: '',
      trip_type: 1,
      interval_time: ''
    }
  },
  methods: {
    open(payload) {
      const {
        orders = [],
        project_name = '',
        use_date = '',
        trip_type = 1,
        interval_time = ''
      } = payload || {}
      this.orders = orders
      this.project_name = project_name
      this.use_date = use_date
      this.trip_type = trip_type
      this.interval_time = interval_time
      this.dialogFormVisible = true
    }
  }
}
</script>

<style scoped lang="less">
.copy-order-info {
  /deep/.el-dialog__body {
    padding: 12px 20px;
  }
  .item {
    display: flex;
    align-items: center;
    min-height: 30px;
    .label {
      width: 80px;
      color: #606266;
    }
    .value {
      color: #333;
      white-space: pre-wrap;
    }
  }
}
</style>
